export { default as LoadingIcon } from './Loading';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Custom/index.js
// module id = 3339
// module chunks = 11